module.exports = __webpack_public_path__ + "static/media/japan.c890b672.jpg";